module.exports = __webpack_public_path__ + "static/media/amb.3df21e54.svg";